import { ENTER } from '@angular/cdk/keycodes';
import { Component, input, OnInit, output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { AppSharedModule } from 'app/app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { Utils } from 'app/utils/utils';
import { ChooseTagsOptions } from '../remove-tags-dialog/remove-tags-dialog.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-add-tags-dialog',
  imports: [AppSharedModule],
  templateUrl: './add-tags-dialog.component.html',
  styleUrls: ['./add-tags-dialog.component.scss'],
})
export class AddTagsDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  readonly options = input<ChooseTagsOptions>();
  readonly modalClosed = output<string[] | void>();

  buttonText: string;
  tags: string[] = [];

  separatorKeysCodes = [ENTER];

  chipInput = new FormControl<string>('');
  hasError = true;
  hasTags;

  ngOnInit() {
    this.chipInput.valueChanges.subscribe((tag) => {
      this.hasError = Utils.replaceNonPrintable(tag) !== tag;
      this.hasTags = !!this.tags.length || !!tag;
    });
  }

  public cancel(): void {
    this.modalClosed.emit();
  }

  public async confirm(): Promise<void> {
    if (this.hasError) {
      return;
    }

    if (this.chipInput.value) {
      this.addTag();
    }
    this.modalClosed.emit(this.tags);
  }

  onTextPasted($event: ClipboardEvent) {
    $event.preventDefault();
    $event.clipboardData
      .getData('Text')
      .split('\n')
      .forEach((value) => {
        this.addTag(value);
      });
  }

  addTag(tagName: string = this.chipInput.value): void {
    const value = Utils.replaceNonPrintable(tagName.trim());

    if (!value) {
      return;
    }

    if (!this.tags.includes(value)) {
      this.tags.push(value);
    }
    this.hasTags = true;
    this.chipInput.setValue('');
  }

  removeTag(tag: string): void {
    const index = this.tags.indexOf(tag);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }

    this.hasTags = !!this.tags.length;
  }
}
